import React, { createContext, useReducer } from "react";
import Reducer from "./Reduser";

const initialState = {
    ui_pw_input_visibility: false,
    ui_fav_box: false,
    show_profile_menu: false,
    ui_chat_box: {
        show: false,
        children: "",
    },
    ui_large_modal: {
        show: false,
        title: "",
        subTitle: "",
        children: "",
    },
    ui_footer_modal: {
        show: false,
        children: "",
    },
    ui_home_performance_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_voting_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_message_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_info_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_profile_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_survey_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_redirect_modal: {
        show: false,
        title: "",
        message: "",
        redirectUrl: "",
    },
    ui_side_panel: {
        show: false,
        title: "",
        children: "",
    },
    ui_multi_pdf_viewer_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_data_info_modal: {
        show: false,
        title: "",
        children: "",
    },
    ui_confirmation_modal: {
        show: false,
        message: "",
        title: "",
        onConfirm: () => {},
        onCancel: () => {},
    },
    changeRole: false,
    signalRConnaction: null,
    requetedUrl: "/app/home",
};

const ContextStore = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    return (
        <Context.Provider value={[state, dispatch]}>
            {children}
        </Context.Provider>
    );
};

export const Context = createContext(initialState);
export default ContextStore;
